import { Compass } from "lucide-react";

export function LoadingState({ message = "Your AI counselling team is working…" }: { message?: string }) {
  return (
    <div className="grid min-h-[55vh] place-items-center text-center">
      <div>
        <div className="mx-auto mb-6 grid h-20 w-20 animate-pulse place-items-center rounded-full bg-moss text-lime"><Compass size={36} /></div>
        <h2 className="font-display text-3xl">{message}</h2>
        <p className="mx-auto mt-3 max-w-md text-sm leading-6 text-ink/60">Five focused agents are analysing your profile, comparing paths, finding skill gaps, and designing your first 30 days.</p>
      </div>
    </div>
  );
}
